function initTextTeaserEqHeight(){
    let $maskTeaserElm = $('.frame-type-mask_teaser_text');
    if($maskTeaserElm.length > 0) {
        let elmheight = 0;
        $maskTeaserElm.find('.item > .item-inner').each(function () {
            if ($(this).outerHeight(true) > elmheight) {
                elmheight = $(this).outerHeight(true);
            }
        });
        $maskTeaserElm.find('.item > .item-inner').css('min-height', elmheight +'px');
    }
}